import { IShareLinkv1 } from "modules/sharing/models";
import { ApiRequest } from "./network";
import { SparrowApi } from "api/network/adapters/SparrowApi";

export class SharingApi {
    constructor(private _sparrowApi: SparrowApi) {}

    public getShareLink = (linkDetails: IShareLinkv1): ApiRequest => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest().post('/{tenant}/api/v1/share/getShareLink', linkDetails)
        );
    }

    public getShareLinkAnonymous = (tenantId: string, linkDetails: IShareLinkv1): ApiRequest => {
        return new ApiRequest(
            this._sparrowApi.CreateAnonymousRequest().post(`/${tenantId}/api/v1/share/getShareLink`, linkDetails)
        );
    }
}